export default __webpack_public_path__ + "static/media/submenu_4_off.ab5df87b.svg";